import Image from 'next/image';
import { Button } from 'antd';
import { motion } from 'framer-motion';
import styled from 'styled-components';
export const CategoryMenuLayoutContainer = styled(motion.div).withConfig({
  displayName: "CategoryMenustyle__CategoryMenuLayoutContainer",
  componentId: "sc-ss4bcz-0"
})(["", " background-color:#171717e5;box-shadow:0px 20px 20px 0px #00000033;"], {
  "position": "absolute",
  "left": "0px",
  "right": "0px",
  "top": "85px",
  "zIndex": "50",
  "marginLeft": "auto",
  "marginRight": "auto",
  "display": "none",
  "maxWidth": "1313px",
  "borderRadius": "40px",
  "paddingLeft": "3rem",
  "paddingRight": "3rem",
  "paddingTop": "2.5rem",
  "paddingBottom": "2.5rem",
  "textAlign": "center"
});
export const CloseIcon = styled(Image).withConfig({
  displayName: "CategoryMenustyle__CloseIcon",
  componentId: "sc-ss4bcz-1"
})(["", " @media (max-width:", "){", "}"], {
  "position": "absolute",
  "right": "2.25rem",
  "top": "1.5rem",
  "height": "18px",
  "width": "18px",
  "cursor": "pointer"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "right": "1rem",
  "top": "1rem"
});
export const SubMenuButton = styled(Button).withConfig({
  displayName: "CategoryMenustyle__SubMenuButton",
  componentId: "sc-ss4bcz-2"
})(["", " box-shadow:0 2px 12px 0 rgba(223,43,65,0.2);&:hover{", "}"], {
  "marginTop": "2.5rem",
  "height": "auto",
  "borderStyle": "none",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(238 132 60 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "45px",
  "paddingRight": "45px",
  "paddingTop": "1rem",
  "paddingBottom": "1rem",
  "fontSize": "1.875rem",
  "lineHeight": "34px",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, {
  "--tw-bg-opacity": "1 !important",
  "backgroundColor": "rgb(238 132 60 / var(--tw-bg-opacity, 1)) !important",
  "--tw-text-opacity": "1 !important",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1)) !important"
});
export const CategoryTitle = styled.div.withConfig({
  displayName: "CategoryMenustyle__CategoryTitle",
  componentId: "sc-ss4bcz-3"
})(["", ""], {
  "textAlign": "left",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
});
export const SubCategoryMenuContainer = styled.div.withConfig({
  displayName: "CategoryMenustyle__SubCategoryMenuContainer",
  componentId: "sc-ss4bcz-4"
})(["", " a{", "}span{", "}"], {
  "display": "flex",
  "textAlign": "left",
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, {
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, {
  "marginRight": "0.75rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 191 60 / var(--tw-text-opacity, 1))"
});
export const MenuWrapper = styled.div.withConfig({
  displayName: "CategoryMenustyle__MenuWrapper",
  componentId: "sc-ss4bcz-5"
})(["", ""], {
  "marginTop": "0.5rem",
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.75rem"
});
export const Wrapper = styled.div.withConfig({
  displayName: "CategoryMenustyle__Wrapper",
  componentId: "sc-ss4bcz-6"
})(["", ""], {
  "display": "grid",
  "gridTemplateColumns": "repeat(5, minmax(0, 1fr))",
  "gap": "2rem"
});